// extracted by mini-css-extract-plugin
module.exports = {"skiljhf":"skiljhf","c14rej0l":"c14rej0l"};